export type ExtensionIndicator =
  | 'loading'
  | 'connecting'
  | 'registering'
  | 'registered'
  | 'disconnected'
  | 'failed'
  | 'unregistered';

export function deriveExtensionIndicator(input: {
  transport: string;
  registration: string;
  isRegistered: boolean;
}): ExtensionIndicator {
  if (input.transport === 'disconnected') return 'disconnected';
  if (input.transport === 'connecting') return 'connecting';
  if (input.transport !== 'connected') return 'connecting';
  if (input.registration === 'registrationFailed') return 'failed';
  if (input.isRegistered) return 'registered';
  if (input.registration === 'unregistered') return 'unregistered';
  return 'registering';
}

export const indicatorColors: Record<ExtensionIndicator, string> = {
  loading: 'bg-yellow-500',
  connecting: 'bg-yellow-500',
  registering: 'bg-yellow-500',
  registered: 'bg-green-600',
  disconnected: 'bg-red-500',
  failed: 'bg-red-500',
  unregistered: 'bg-red-500',
};
